import { render, staticRenderFns } from "./ClinicsComponent.vue?vue&type=template&id=4e2e3f62&scoped=true&"
import script from "./ClinicsComponent.vue?vue&type=script&lang=js&"
export * from "./ClinicsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClinicsComponent.vue?vue&type=style&index=0&id=4e2e3f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e3f62",
  null
  
)

export default component.exports